import api from './api';
import { cleanAnalyticsParams } from './executiveAnalytics';
import { cleanParams, normalizeListResponse } from './violations';

/*
 * Бизнес-аналитика (BM-FE-TZ-002B/002C, проверено по production OpenAPI
 * 24.10.2026).
 *
 * GET /analytics/business-summary — тот же ExecutiveSummaryResponse, что и
 * /analytics/executive-summary, включая legacy-имена полей violations_*:
 * business_* полей в ответе нет. Параметры те же: массивы scope, rule_ids,
 * from/to и per-table comparison_* / shift_*.
 *
 * /business/events — бизнес-события. Это не violation events: подменять их
 * нельзя. Фильтр по объекту — одиночный id (camera_id / room_id / …).
 */

export const getBusinessSummary = (params = {}, { signal } = {}) =>
  api.get('/analytics/business-summary', {
    params: cleanAnalyticsParams(params),
    signal,
  }).then((response) => response.data);

export const listBusinessEvents = (params = {}, { signal } = {}) =>
  api.get('/business/events', {
    params: cleanParams(params),
    signal,
  }).then((response) => normalizeListResponse(response.data, params.limit));

/** 404 — событие сменило категорию или недоступно: показываем это отдельно. */
export const getBusinessEvent = (eventId) =>
  api.get(`/business/events/${eventId}`).then((response) => response.data);

/** Только читает; тело строго `{event_ids}` или `{filters}`. */
export const countSelectedBusinessEvents = (body) =>
  api.post('/business/events/count-selected', body).then((response) => response.data);

/**
 * 404 без detail-объекта или 405/501 — роута нет совсем. 404 с осмысленным
 * detail (например, недоступный объект) — это ответ существующего роута.
 */
export const isRouteMissing = (error) => {
  const status = error?.response?.status;
  if (status === 405 || status === 501) return true;
  if (status !== 404) return false;
  const detail = error?.response?.data?.detail;
  return detail == null || detail === 'Not Found';
};
